export class WebSocketEventModel {
    name: string;
    function: string;
}
